module.exports = __webpack_public_path__ + "img/Lease_Signing_Logo.67b82fe2.png";